import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  align-self: center;\n  cursor: pointer;\n  border: 0;\n  background: none;\n  font-size: 20px;\n  color: #333;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: Lato-Regular, sans-serif;\n  font-size: 14px;\n  font-weight: normal;\n  padding: ", " 0px;\n  text-decoration: underline;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: Lato-Regular, sans-serif;\n  font-size: ", ";\n  font-weight: bold;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 0px ", " 0px 12px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding-top: ", ";\n  width: ", ";\n  color: #333;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  padding: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: row;\n  height: fit-content;\n  margin: 10px 0;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '../../icon';
import { faTimes, faInfoCircle, faExclamationTriangle, faExclamationCircle } from '../../icon/sets/regular';
var Wrapper = styled.div(_templateObject(), function (p) {
  return p.invert ? p.theme[p.brand] : p.theme.tint(p.theme[p.brand]);
}, function (p) {
  return p.theme[p.brand];
}, function (p) {
  return p.theme.spacing(0.5);
});
var ColoredTab = styled.div(_templateObject2(), function (p) {
  return p.theme[p.brand];
}, function (p) {
  return p.theme.spacing(1);
});
var PaddedWrapper = styled.div(_templateObject3(), function (p) {
  return p.theme.spacing(2, 2, 2, 1);
});
var SideWrapper = styled.div(_templateObject4(), function (p) {
  return p.theme.spacing(0.5);
}, function (p) {
  return p.theme.spacing(3);
});
var BannerContent = styled.div(_templateObject5(), function (p) {
  return p.theme.spacing(2);
});
var Span = styled.span(_templateObject6(), function (p) {
  return p.invert ? p.theme.highContrast(p.theme[p.brand]) : p.theme.highContrast(p.theme.tint(p.theme[p.brand]));
}, function (p) {
  return p.theme.spacing(2);
});
var Link = styled.a(_templateObject7(), function (p) {
  return p.invert ? p.theme.highContrast(p.theme[p.brand]) : p.theme.highContrast(p.theme.tint(p.theme[p.brand]));
}, function (p) {
  return p.theme.spacing(0.5);
});
var DismissButton = styled.button(_templateObject8(), function (p) {
  return p.theme.spacing(3);
}, function (p) {
  return p.theme.spacing(3);
});

var Banner = function Banner(_ref) {
  var _ref$brand = _ref.brand,
      brand = _ref$brand === void 0 ? 'warning' : _ref$brand,
      _ref$shouldDisplay = _ref.shouldDisplay,
      shouldDisplay = _ref$shouldDisplay === void 0 ? false : _ref$shouldDisplay,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      message = _ref.message,
      linkUrl = _ref.linkUrl,
      linkText = _ref.linkText;

  var _useState = useState(shouldDisplay),
      _useState2 = _slicedToArray(_useState, 2),
      displayBanner = _useState2[0],
      setDisplayBanner = _useState2[1];

  var onDismiss = function onDismiss() {
    return setDisplayBanner(false);
  };

  return displayBanner && /*#__PURE__*/React.createElement(Wrapper, {
    brand: brand,
    invert: invert
  }, /*#__PURE__*/React.createElement(ColoredTab, {
    brand: brand
  }), /*#__PURE__*/React.createElement(PaddedWrapper, null, /*#__PURE__*/React.createElement(SideWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    icon: {
      warning: faExclamationCircle,
      danger: faExclamationTriangle,
      info: faInfoCircle
    }[brand]
  })), /*#__PURE__*/React.createElement(BannerContent, null, /*#__PURE__*/React.createElement(Span, {
    brand: brand,
    invert: invert
  }, message), /*#__PURE__*/React.createElement(Link, {
    brand: brand,
    invert: invert,
    href: linkUrl
  }, linkText)), /*#__PURE__*/React.createElement(DismissButton, {
    onClick: onDismiss
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: faTimes
  }))));
};

export default Banner;